import React from "react";
import {
  Grid,
  GridColumn as Column,
  GridDetailRowProps,
} from "@progress/kendo-react-grid";
import { GridColumnProps } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import styles from './DataTable.module.scss';
import styled from 'styled-components';

interface ExpandableGridProps {
  data: any[];
  dataItemKey: string;
  columns: GridColumnProps[];
  detailComponent: React.ComponentType<GridDetailRowProps>;
  style?: React.CSSProperties;
  scrollable?: "none" | "scrollable" | "virtual";
  height?: string;
  className?: string;
}

const StyledGrid = styled(Grid)`
  .k-column-title {
    min-width: 0;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    overflow: hidden;
    font-weight: bold; /* Make the font bold */
  }
`;

export const ExpandableGrid: React.FC<ExpandableGridProps> = ({
  data,
  dataItemKey,
  columns,
  detailComponent: DetailComponent,
  style = {},
  scrollable = "scrollable",
  height = "100%",
  className,
}) => {
  const defaultStyle = {
    height,
    border: "1px solid #ddd",
    ...style,
  };

  return (
    <StyledGrid
      data={data}
      dataItemKey={dataItemKey}
      detail={DetailComponent}
      style={defaultStyle}
      scrollable={scrollable}
      className={className}
    >
      {columns.map((column, index) => (
        <Column 
          key={index} 
          {...column}
          className={styles.headerColumn}
          title={column.title}
        />
      ))}
    </StyledGrid>
  );
};